import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import './registerServiceWorker'
import UebersichtMarkerPublic from './components/UebersichtMarkerPublic'
import UebersichtControlCenter from './components/UebersichtControlCenter'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

// Häufig benutzte Bootstrap-Komponenten und Plugins registrieren
import { ToastPlugin, BModal, BButton, BForm, BFormGroup, BFormTextarea } from 'bootstrap-vue'
Vue.use(ToastPlugin)
Vue.component('b-modal', BModal)
Vue.component('b-button', BButton)
Vue.component('b-form', BForm)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-textarea', BFormTextarea)

Vue.component('uebersicht-marker-public', UebersichtMarkerPublic)
Vue.component('uebersicht-control-center', UebersichtControlCenter)


Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
